export default "__VITE_ASSET__CdG6__38__"